import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@ui/alert-dialog";
import TranslatedText from "@components/items/display/TranslatedText";
import { translate } from "@modules/localizations/translate";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";

const DeleteAccountDialog = ({
  setOpenDialog,
}: {
  setOpenDialog: (state: boolean) => void;
}) => {
  const navigate = useAppNavigate();
  return (
    <AlertDialog>
      <AlertDialogTrigger>
        <TranslatedText
          text={`settings.dialogs.${"delete account"}`}
          className="col-span-2 w-full cursor-pointer text-[15px] !text-[#FF5153] hover:opacity-70 ltr:text-right rtl:text-left"
        />
      </AlertDialogTrigger>
      <AlertDialogContent className="border-none bg-white dark:bg-[#37383F]">
        <AlertDialogHeader className="sm:text-start">
          <AlertDialogTitle>
            <TranslatedText
              text={`settings.dialogs.${"delete account"}`}
              className="text-[20px] font-medium dark:text-white"
            />
          </AlertDialogTitle>
          <div className="text-muted-foreground flex flex-col items-start justify-center gap-2 pb-5 pt-2 text-sm dark:text-white">
            <TranslatedText
              text={`settings.dialogs.accountDeactivation.${"title"}`}
            />
            <TranslatedText
              text={`settings.dialogs.accountDeactivation.${"deactivationNotice"}`}
            />
            <TranslatedText
              text={`settings.dialogs.accountDeactivation.${"reactivationInstructions"}`}
            />
            <TranslatedText
              text={`settings.dialogs.accountDeactivation.${"permanentDeletionWarning"}`}
            />
            <div>
              {translate(
                `settings.dialogs.accountDeactivation.cancelSubscription.1`
              )}{" "}
              <span
                className="cursor-pointer font-medium text-red-500 underline"
                onClick={() => {
                  navigate("/settings?tab=subscription");
                }}
              >
                {translate(
                  `settings.dialogs.accountDeactivation.cancelSubscription.2`
                )}
              </span>{" "}
              {translate(
                `settings.dialogs.accountDeactivation.cancelSubscription.3`
              )}
            </div>
          </div>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-x-4">
          <AlertDialogAction
            className="bg-[#D9D9D9] hover:bg-[#D9D9D9] hover:opacity-85"
            onClick={() => setOpenDialog(true)}
          >
            <TranslatedText
              text={`settings.dialogs.${"delete account"}`}
              className="text-[16px] font-normal !text-[#FF5153]"
            />
          </AlertDialogAction>
          <AlertDialogCancel className="hover:opacity-85 dark:border-none dark:hover:bg-transparent">
            <TranslatedText
              text={`settings.dialogs.${"keep my account"}`}
              className="text-[16px] font-normal !text-[#FF5153]"
            />
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteAccountDialog;
